import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { setUtmTags } from 'root-redux/actions/common'
import { sendUserConfigAction } from 'root-redux/actions/user'

import { getAppConfigMap } from 'helpers/getAppConfigMap'

export const useUtmTags = () => {
  const { search } = useLocation()
  const dispatch = useDispatch()
  const URLParams = new URLSearchParams(search)
  const utmTagsFromUrl = Object.fromEntries(URLParams.entries())
  const { appName } = getAppConfigMap()

  useEffect(() => {
    if (utmTagsFromUrl.utm_source) {
      dispatch(setUtmTags(utmTagsFromUrl))
      dispatch(
        sendUserConfigAction({
          utm_tags: utmTagsFromUrl,
          domain: appName,
        }),
      )
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])
}
